//messages.js
export default {
    parent_id: "Parent Id",
    stripe_id: "Stripe Id",
    zoho_customer_id: "Zoho Customer Id",
    organisation_type_id: "Organisation Type Id",
    company: "Company",
    company_short: "Company Short",
    website: "Website",
    correspondence_method: "Correspondence Method",
    currency_code: "Currency Code",
    turn_around_days: "Turn Around Days",
    has_nda: "Has Nda",
    has_contract: "Has Contract",
    ship_label_type: "Ship Label Type",
    logo_id: "Logo Id",
    packing_list_fields: "Packing List Fields",
    logo: "Logo",
    status: "Status",
    edit_shipping_carrier: "Edit Shipping Carrier",
    add_shipping_carrier: "Add Shipping Carrier",
    delete_shipping_carrier: "Delete Shipping Carrier",
    shipping_carriers: "Shipping Carriers",
    delete_shipping_carrier_confirm: "This action is not reversible!",
};
